import React from 'react';
import './ChangeStatusStepper.css';
import { CHANGE_STATUS_PIPELINE, labelChangeStatus } from '../changeLabels';

export type ChangeStatusStepState = 'done' | 'current' | 'upcoming' | 'cancelled';

export function resolveChangeStatusStepState(
  step: string,
  currentStatus: string,
  pipeline: string[] = CHANGE_STATUS_PIPELINE,
): ChangeStatusStepState {
  if (currentStatus === 'cancelada') {
    return 'cancelled';
  }
  if (currentStatus === 'encerrar') {
    return pipeline.indexOf(step) >= 0 ? 'done' : 'upcoming';
  }
  const currentIndex = pipeline.indexOf(currentStatus);
  const stepIndex = pipeline.indexOf(step);
  if (stepIndex < 0) {
    return 'upcoming';
  }
  if (currentIndex < 0) {
    return stepIndex === 0 ? 'current' : 'upcoming';
  }
  if (stepIndex < currentIndex) return 'done';
  if (stepIndex === currentIndex) return 'current';
  return 'upcoming';
}

type Props = {
  currentStatus: string;
};

const ChangeStatusStepper: React.FC<Props> = ({ currentStatus }) => {
  const cancelled = currentStatus === 'cancelada';

  return (
    <nav
      className="change-status-stepper"
      aria-label="Trilho de status da mudança"
    >
      <ol className="change-status-stepper__list">
        {CHANGE_STATUS_PIPELINE.map((status, index) => {
          const state = resolveChangeStatusStepState(status, currentStatus);
          const label = labelChangeStatus(status);
          return (
            <li
              key={status}
              className={`change-status-stepper__item change-status-stepper__item--${state}`}
            >
              {index > 0 ? (
                <span className="change-status-stepper__connector" aria-hidden="true" />
              ) : null}
              <span
                className="change-status-stepper__dot"
                aria-hidden="true"
              >
                {state === 'done' ? '✓' : index + 1}
              </span>
              <span className="change-status-stepper__label">
                {label}
                {state === 'current' ? (
                  <span className="visually-hidden"> (atual)</span>
                ) : null}
              </span>
            </li>
          );
        })}
      </ol>
      {currentStatus === 'encerrar' ? (
        <p className="change-status-stepper__completed mb-0" role="status">
          Mudança <strong>encerrada</strong> — trilho concluído.
        </p>
      ) : null}
      {cancelled ? (
        <p className="change-status-stepper__cancelled mb-0" role="status">
          Status atual: <strong>Cancelada</strong> — fora do trilho principal.
        </p>
      ) : null}
    </nav>
  );
};

export default ChangeStatusStepper;
